import {makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "../../../components/toast/ErrorToast";

export class OrderTicketsManagementFeature {
    constructor(application) {
        this.PedidoInicial = {
            Cliente: {
                Vendedor: {
                    BejermanId: "0001",
                    Nombre: "Nombre Vendedor"
                },
                Nombre: "Nombre Cliente",
                RazonSocial: "Razón Social Cliente"
            }
        }
        this._orders = [
            {
                Id: 1,
                Numero: "12345",
                FechaCreacion: "2022-01-01",
                Estado: "Abierto",
                ComentarioOriginal: "Comentario Original"
            },
            {
                Id: 2,
                Numero: "23456",
                FechaCreacion: "2022-02-02",
                Estado: "Cerrado",
                ComentarioOriginal: "Comentario Original"
            }
        ]
        this._application = application
        this._loaded = true

        makeObservable(this, {
            PedidoInicial: observable,
            _orders: observable,
            _loaded: observable
        })
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get orders() {
        return this._orders;
    }

    set orders(value) {
        this._orders = value;
    }

    addTicket(name, email, issue, detail, files, handleSuccess) {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                handleSuccess();
            },
            handlesError: (response) => {
                errorToast("No se pudo enviar la solicitud.");
            }
        });
        const token = this._application.session().getToken();
        return this._application.apiClient().addTicket(name, email, issue, detail, files, token, responseHandler)
    }
}